module.exports = __webpack_public_path__ + "img/babo-right.3d4b1f85.png";